import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import cancelImage from "../assets/images/cancel.png";
import editImage from "../assets/images/edit.svg";
import saveImage from "../assets/images/update.png";
import removeImage from "../assets/images/remove.png";
import deleteTodo from "../redux/todos/thunk/deleteTodo";
import updateColor from "../redux/todos/thunk/updateColor";
import updateStatus from "../redux/todos/thunk/updateStatus";
import updateTodo from "../redux/todos/thunk/updateTodo";

export default function Todo({ todo }) {
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const saveRef = useRef(null);
  const [inputText, setInputText] = useState("");
  const { text, id, completed, color } = todo;

  const handleStatusChange = (todoId) => {
    dispatch(updateStatus(todoId, completed));
  };

  const handleColorChange = (todoId, color) => {
    dispatch(updateColor(todoId, color));
  };

  const handleDelete = (todoId) => {
    dispatch(deleteTodo(todoId));
  };
  const submitEdit = (todoId) => {
    setIsEdit(false);
    dispatch(updateTodo(inputText, todoId));
    setInputText("");
  };

  const handleEdit = (todoText, todoId) => {
    setIsEdit(true);
    setInputText(todoText);
  };
  const handleEnterKey = (event) => {
    if (event.key === "Enter") {
      console.log("Updating todo... ✅");
      saveRef.current.click();
    }
  };
  return (
    <div className="flex justify-start items-center p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0">
      <div
        className={`relative rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 ${
          completed && "border-green-500 focus-within:border-green-500"
        }`}
      >
        <input
          type="checkbox"
          checked={completed}
          onChange={() => handleStatusChange(id)}
          className="opacity-0 absolute rounded-full cursor-pointer"
        />
        {completed && (
          <svg
            className="fill-current w-3 h-3 text-green-500 pointer-events-none"
            viewBox="0 0 20 20"
          >
            <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
          </svg>
        )}
      </div>

      <div className={`select-none flex-1 ${completed && "line-through"}`}>
        {/* {} */}
        {isEdit ? (
          <input
            defaultValue={inputText}
            type="text"
            id="input"
            className="w-full p-2 border border-grey focus:outline-0"
            onChange={(e) => setInputText(e.target.value)}
            onKeyDown={handleEnterKey}
          />
        ) : (
          text
        )}
      </div>

      {/* edit todo content */}

      {isEdit ? (
        <>
          <div className={`flex-shrink-0 h-6 w-6 ml-auto cursor-pointer`}>
            <button
              onClick={() => {
                setInputText("");
                setIsEdit(false);
              }}
            >
              <img src={removeImage} alt="discard" title="discard" />
            </button>
          </div>
          <div className={`flex-shrink-0 h-5 w-5 ml-auto cursor-pointer`}>
            <button onClick={() => submitEdit(id)} ref={saveRef}>
              <img src={saveImage} alt="save" title="save" />
            </button>
          </div>
        </>
      ) : (
        <div className={`flex-shrink-0 h-6 w-6 ml-auto cursor-pointer`}>
          <button onClick={() => handleEdit(text, id)}>
            <img src={editImage} alt="edit" title="edit todo" />
          </button>
        </div>
      )}

      {/* end */}
      <div
        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-green-500 border-green-500 ${
          color === "green" && "bg-green-500"
        }`}
        onClick={() => handleColorChange(id, "green")}
      ></div>

      <div
        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-yellow-500 border-yellow-500 ${
          color === "yellow" && "bg-yellow-500"
        }`}
        onClick={() => handleColorChange(id, "yellow")}
      ></div>

      <div
        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-red-500 border-red-500 ${
          color === "red" && "bg-red-500"
        }`}
        onClick={() => handleColorChange(id, "red")}
      ></div>

      <img
        src={cancelImage}
        className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
        alt="Cancel"
        onClick={() => handleDelete(id)}
      />
    </div>
  );
}
